import React from 'react';

const MeetingItem = ({ meeting }) => {
  const getMeetingTypeClass = (type) => {
    if (!type || type === '-') return '';
    if (type.includes('D')) return 'druid';
    if (type.includes('B')) return 'bard';
    if (type.includes('Eu')) return 'eubat';
    return '';
  };

  const isSamainMeeting = (meeting) => {
    return meeting.lodge === 'Samain';
  };

  const isBardalandMeeting = (meeting) => {
    return !meeting.region; // Bardaland meetings have no region field
  };

  const isJarnbaralandMeeting = (meeting) => {
    return meeting.region === 'Järnbäraland';
  };

  const isFolkungalandMeeting = (meeting) => {
    return meeting.region === 'Folkungaland';
  };

  const isSpecialMeeting = (meeting) => {
    return meeting.lodge?.includes('Storloge') || 
           meeting.lodge?.includes('RiksStorLogen') ||
           meeting.details?.includes('IGLD');
  };

  const hasImportantInfo = (meeting) => {
    return meeting.dresscode === 'Frack' || 
           meeting.meeting.includes('DGG') || 
           meeting.meeting.includes('BGG') ||
           meeting.meeting.includes('Rec') ||
           isSpecialMeeting(meeting);
  };

  const getDisplayTime = () => {
    if (meeting.time && meeting.time !== '-') {
      return meeting.time;
    }
    return '';
  };

  const getShortLodgeName = (lodge) => {
    if (!lodge || lodge === '-') return '';
    
    // Handle special lodge names
    if (lodge.includes('Storloge')) return 'Storloge';
    if (lodge.includes('RiksStorLogen')) return 'IGLD';
    
    // Return first word or abbreviation for regular lodges
    const words = lodge.split(' ');
    if (words.length > 1) {
      return words[0];
    }
    return lodge.length > 8 ? lodge.substring(0, 8) + '...' : lodge;
  };

  const getShortDetails = (details) => {
    if (!details || details === '-') return '';
    if (details.length > 20) {
      return details.substring(0, 17) + '...';
    }
    return details;
  };

  return (
    <div 
      className={`meeting-item ${getMeetingTypeClass(meeting.type)} ${hasImportantInfo(meeting) ? 'important' : ''} ${isSpecialMeeting(meeting) ? 'special' : ''} ${isSamainMeeting(meeting) ? 'samain' : ''} ${isBardalandMeeting(meeting) ? 'bardaland' : ''} ${isJarnbaralandMeeting(meeting) ? 'jarnbaraland' : ''} ${isFolkungalandMeeting(meeting) ? 'folkungaland' : ''}`}
      title={`${meeting.lodge} - ${meeting.details || 'Möte'} ${meeting.time !== '-' ? `kl ${meeting.time}` : ''}`}
    >
      <div className="meeting-item-header">
        {getDisplayTime() && (
          <span className="meeting-item-time">{getDisplayTime()}</span>
        )}
        {meeting.dresscode === 'Frack' && (
          <span className="dresscode-indicator">👔</span>
        )}
      </div>
      
      <div className="meeting-item-lodge">
        {getShortLodgeName(meeting.lodge)}
      </div>
      
      {meeting.type && meeting.type !== '-' && (
        <div className="meeting-item-type">
          {meeting.type}
        </div>
      )}
      
      {meeting.meeting && meeting.meeting !== '-' && (
        <div className="meeting-item-special">
          {meeting.meeting}
        </div>
      )}
      
      {meeting.details && meeting.details !== '-' && (
        <div className="meeting-item-details">
          {getShortDetails(meeting.details)}
        </div>
      )}
      
      {meeting.city && meeting.city !== '-' && (
        <div className="meeting-item-city">
          {meeting.city}
        </div>
      )}
    </div>
  );
};

export default MeetingItem;